import Hosts from '../../../../Hosts';

const object_type = 'store/feature/value/product'
const object_type2 = 'store/feature/value/product/parent'
const object_type3 = 'store/feature/value/product/parent/next'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = (companycode, parent_id) => `${Hosts.SIMCore_API}/${object_type2}/${companycode}/${parent_id}`
const api_list_order = (companycode, parent_id) => `${Hosts.SIMCore_API}/${object_type3}/${companycode}/${parent_id}`

const base_endpoint = '/store_feature_value'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    //view: `${base_endpoint}_view`,
    view: `${base_endpoint}`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        feature: '',
        name: '',
        description: '',
        bgColor: '',
        borderColor: '',
        media: {
            image: [], 
            doc: []
        },
        status: true,
        order: 0,
        language: []
    }
}
export {
    endpoints,
    object_type,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route,
    api_list_order
}